import { Component } from "@angular/core";

@Component({
  selector: "ngx-svg-sidebar-open-icon",
  template: `
    <svg
      stroke-width="2"
      viewBox="0 0 24 24"
      stroke-linecap="round"
      stroke-linejoin="round"
      height="1em"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
      [style.scale]="1.75"
      [style.stroke]="'#000'"
      [style.fill]="'none'"
    >
      <rect width="18" height="18" x="3" y="3" rx="2"></rect>
      <path d="M9 3v18"></path>
      <path d="m14 9 3 3-3 3"></path>
    </svg>
  `,
  standalone: true,
})
export class SvgSidebarOpenIconComponent {}
